enum SettingsConfigType {
  INT = "int",
  DOUBLE = "double",
  STRING = "string",
  BOOLEAN = "boolean",
  DATE = "date",
  EMAIL = "email",
  KEY = "key",
  USER_KEY = "user_key",
  INTEGRATION = "integration",
  LIST = "list",
  OAUTH = "oauth",
	GOOGLE_PICKER = "google_picker",
	CURRENT_USER = "current_user",
}

export { SettingsConfigType };
